import { ReactElement } from 'react';
import { ErrorOutline } from '@mui/icons-material';
import { formatNumber } from '~/utils/format';
import styles from './ProgramCard.module.scss';

interface IProps {
  amount: number;
  title: string;
  hasHighPriority: boolean;
  onClick: () => void;
}

const ProgramCard = ({ amount, title, hasHighPriority, onClick }: IProps): ReactElement => (
  <div role="presentation" className={styles.smallCard} onClick={onClick}>
    <div className={styles.inner}>
      <div className={styles.amount}>{formatNumber(amount)}</div>
      <div className={styles.title} title={title}>
        {title}
      </div>
      {hasHighPriority && (
        <div className={styles.highPriorityIcon}>
          <ErrorOutline />
        </div>
      )}
    </div>
  </div>
);

export default ProgramCard;
